import { render, staticRenderFns } from "./Tabular.vue?vue&type=template&id=e6b517ca&scoped=true&"
import script from "./Tabular.vue?vue&type=script&lang=js&"
export * from "./Tabular.vue?vue&type=script&lang=js&"
import style0 from "./Tabular.vue?vue&type=style&index=0&id=e6b517ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b517ca",
  null
  
)

export default component.exports